import type { Component } from 'vue'

export type SubmissionAction = {
	buttonText: string
	component?: Component /** For Retry we do not open a modal so component is optional. */
	componentProps?: Record<string, unknown>
	onClick?: (planId: string) => Promise<void> /** Used for Retry only */
}

export type SubmissionStatus = {
	status: string /* we might see one we've never added to FE */
	createdAt?: string
	updatedAt: string
	submitted?: string
	submissionId: string
}

export enum EverplansEmailStatusEnum {
	VALID = 'valid',
	BLANK = 'blank',
	INVALID = 'invalid',
	DUPLICATE = 'duplicate',
	ERROR = 'error',
}

export type EverplansEmailStatus = {
	status: EverplansEmailStatusEnum
	placeholder_created?: boolean
	invite_sent: boolean
	message: string
}

type EverplansResult = {
	success: boolean
	message: string
}

type EverplansEventType = string

export type EverplansSubmissionStatus = SubmissionStatus & {
	requestedAccountTier?: string | null
	accountTier: string | null
	emailStatus: EverplansEmailStatus | null
	paymentStatus: string | null
	result: EverplansResult | null
	lastRequestType: EverplansEventType | null
	lastSubmittedEmail?: string | null
	paymentAmount?: string // comes from API as a string to prevent float errors
}

export type OapSubmissionStatus = SubmissionStatus & {
	provider: string
}

export type SubmissionStatusGroup = {
	insurance?: SubmissionStatus
	oap?: SubmissionStatus
	everplans?: EverplansSubmissionStatus
}

export type RemoteSubmissionStatus = {
	latestSessionId?: string | null
	statuses: SubmissionStatusGroup
}
